import { AfterContentInit, Component, ContentChildren, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, ViewEncapsulation } from '@angular/core';
import { TlTabComponent } from './tl-tab.component';

@Component({
  selector: 'tl-tabs',
  styleUrls: ['./tl-tabs.scss'],
  templateUrl: './tl-tabs.component.html',
  encapsulation: ViewEncapsulation.None,
  host: {
    'class': 'tl-tabs'
  }
})
export class TlTabsComponent implements OnInit, OnChanges, AfterContentInit {

  /** 激活的索引 */
  @Input('activeIndex') private _activeIndex: number = 0;
  public get activeIndex(): number { return this._activeIndex; }
  public set activeIndex(v: number) { this._activeIndex = v; }
  @Output() public activeIndexChange: EventEmitter<number> = new EventEmitter<number>();


  /** 子组件 tab */
  @ContentChildren(TlTabComponent, { descendants: true }) public tabComponents: QueryList<TlTabComponent>;

  constructor(
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
  }

  ngAfterContentInit(): void {
    setTimeout(() => {
      this._setChildrenActive();
    });
    this.tabComponents.changes.subscribe(() => {
      this._setChildrenActive();
    });
  }

  public labelClick = (idx: number) => {
    this.activeIndex = idx;
    this.activeIndexChange.emit(this.activeIndex);
    this._setChildrenActive();
  }

  private _setChildrenActive = () => {
    if (!this.tabComponents) return;
    this.tabComponents.forEach((tab: TlTabComponent, idx) => {
      tab.active = this.activeIndex === idx;
    });
  }



}
